import {Component, OnDestroy, OnInit} from '@angular/core';
import {GenericDatatableComponent} from '../../../shared/components/generic-datatable/generic-datatable.component';
import {
  ChangeCompaniesPageSizeAction,
  ClearCompaniesAction,
  LoadCompaniesAction, LoadCompaniesMissingDataAction,
  OrderCompaniesByAction, PageCompaniesToAction,
  QuickSearchCompaniesAction, SearchCompaniesAction,
  ToggleSearchCompaniesAction
} from '../../actions/companies-list';
import {SetPreferencesAction} from '../../../shared/actions/preferences';
import {CompaniesFilter, CompaniesList} from '../../models/companies-list';
import {OrderItem} from '../../../order/models/order-item';
import * as fromCompanies from '../../reducers';
import {select} from '@ngrx/store';
import * as fromRoot from '../../../shared/reducers';

@Component({
  selector: 'storever-companies-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class CompaniesListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    if (this.router.url.split('?')[0].split('/')[1] !== 'anomalies') {
      this.dataConfig = this.companyDataService.getCompaniesListData().dataTabs[0].dataConfig;
    }
    super.ngOnInit();
    this.loadDataOnChangeUrl('name', 'companiees_row_size');
  }

  ngOnDestroy(): void {
    this.storeRoot.dispatch(new ClearCompaniesAction());
    this.dataConfig.form.markAsPristine();
  }

  loadData(): void {
    if (this.router.url.split('?')[0].split('/')[1] !== 'anomalies') {
      this.storeRoot.dispatch(new LoadCompaniesAction());
    } else {
      this.storeRoot.dispatch(new LoadCompaniesMissingDataAction());
    }
  }

  storeSelect(): void {
    this.pageSize$ = this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, 'companiees_row_size'));
    this.count$ = this.storeCompany.pipe(select(fromCompanies.selectors.getCompanyCount));
    this.showFilter$ = this.storeCompany.pipe(select(fromCompanies.selectors.getCompanyShowFilter));
    this.data$ = this.storeCompany.pipe(select(fromCompanies.selectors.getCompanies));
    //   let pageSizeInit = true ;
    //   this.sub$ = this.pageSize$.subscribe(pageSize => {
    //     if ( pageSizeInit && pageSize) {
    //     this.storeShipping.dispatch(new ChangeCompaniesPageSizeAction(pageSize));
    //     pageSizeInit = false;
    //   }
    // });
    //   this.subscriptions.push(this.sub$);
  }

  orderByChanged(orderBy: string): void {
    this.storeCompany.dispatch(new OrderCompaniesByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    if (pageSize === -1) {
      pageSize = 100;
    }
    this.storeCompany.dispatch(new SetPreferencesAction({name: 'companiees_row_size', value: '' + pageSize}));
    this.storeCompany.dispatch(new ChangeCompaniesPageSizeAction(pageSize));
  }

  pageChanged(page: number): void {
    this.storeCompany.dispatch(new PageCompaniesToAction(page));
  }

  applyFilter(filterForm: CompaniesFilter): void {
    let countryCode;
    if (filterForm && filterForm.countryCode && filterForm.countryCode.code) {
      countryCode = filterForm.countryCode.code;
      filterForm.countryCode = countryCode;
    }

    this.storeCompany.dispatch(new SearchCompaniesAction(this.filterDeleteIfNilService.flatten(filterForm)));
  }

  applyQuickFilter(query: string): void {
    this.storeCompany.dispatch(new QuickSearchCompaniesAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeCompany.dispatch(new ToggleSearchCompaniesAction(!showFilter));
  }

  dispatchClearDataAction(): void {
    this.storeCompany.dispatch(new ClearCompaniesAction());
  }

  dispatchToggleSelected(order: OrderItem): void {
  }

  toggleSelected(order: OrderItem): void {
  }

  routerLink(route: string, data: CompaniesList): { path: string[], fragment?: string } {
    return {path: ['/', 'companies', 'detail', data.uuid], fragment: 'Contract'}
    // return {path: ['/', data.uuid, 'contracts', 'list' ], fragment: null };
  }

  disablePagination(): boolean {
    return false;
  }

  // tslint:disable-next-line:no-any
  actionButton(type: string, data?: any): void {
    this.router.navigate(['/', 'companies', 'add']);
  }

}

